<template>
  <a-modal v-model:visible="confirmVisible" width="400px" title="提示" centered @cancel="onCancel">
    <div>随访任务未完成，请及时处理</div>
    <template #footer>
      <a-button type="primary" @click="onOk">继续处理</a-button>
    </template>
  </a-modal>
</template>

<script setup>
import { defineExpose, ref } from 'vue'
const confirmVisible = ref(false)
const initModal = () => {
  confirmVisible.value = true
}
function onCancel() {
  confirmVisible.value = false
}
const onOk = () => {
  confirmVisible.value = false
}
defineExpose({
  initModal
})
</script>

<style scoped lang="scss"></style>
